import React from 'react'

const MessageBox = ({data,status}) => {
  return (
    <>
    {status==='success'
    ?
        <div className='message-box-body'>
          <p>{data}</p>
    </div>
    :
    <div className='message-box-body2'>
          <p>{data}</p>
    </div>}
    </>
  )
}

export default MessageBox